import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-sofyre-user-manual';

const cards = [
  {
    title: 'Small RV or Room',
    image: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0d4269cdc5ed362df0782.webp?w=1000',
    tag: '1 POUCH',
    description: 'Every entry point covered',
  },
  {
    title: 'Full Home',
    image: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0d432af9c53363ac7d0cc.webp?w=1000',
    tag: '2-3 POUCHES',
    description: 'Every room + garage + basement',
  },
  {
    title: 'Large Home + Outbuildings',
    image: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0d43dc8f8b66df06bb4f7.webp?w=1000',
    tag: '4-6 POUCHES',
    description: 'Home + shed + your garage',
  },
  {
    title: 'Farm / Full Property',
    image: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0d448b84ea539512d85cb.webp?w=1000',
    tag: '8+ POUCHES',
    description: 'Barn + feed storage + perimeter',
  },
];

const cardHtml = card => `
  <article class="sofyre-user-manual__card" data-attribute="sofyre-user-manual__card">
    <div class="sofyre-user-manual__card-title" data-attribute="sofyre-user-manual__card-title">${card.title}</div>
    <div class="sofyre-user-manual__card-body">
      <img
        class="sofyre-user-manual__card-image"
        data-attribute="sofyre-user-manual__card-image"
        src="${card.image}"
        alt=""
        loading="lazy"
      >
      <div class="sofyre-user-manual__card-tag" data-attribute="sofyre-user-manual__card-tag">${card.tag}</div>
      <div class="sofyre-user-manual__card-description" data-attribute="sofyre-user-manual__card-description">${card.description}</div>
    </div>
  </article>
`;

const buttonHtml = buttonPrimary({
  text: 'ADD TO CART',
  backgroundColor: '#CCF46F',
  color: '#23372B',
  radius: 100,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/09/08/image-6a9fb3c9503aaa5482a117ec.png',
  },
});

const contentHtml = `
  <div class="sofyre-user-manual container" data-attribute="sofyre-user-manual">
    <div class="sofyre-user-manual__panel">
      <header class="sofyre-user-manual__header" data-attribute="sofyre-user-manual__header">
        <h2 style="text-align: center">Directions Of Use</h2>
        <p style="text-align: center">Our concentrated 4-oil formula starts working within 72 hours — and keeps mice gone for 90 days straight.<br>Here's exactly how to use it.</p>
      </header>

      <div class="sofyre-user-manual__cards" data-attribute="sofyre-user-manual__cards">
        ${cards.map(cardHtml).join('')}
      </div>

      <div class="sofyre-user-manual__recommendation" data-attribute="sofyre-user-manual__recommendation">
        <p>OUR RECOMMENDATION</p>
        <p>We recommend replacing pouches every 90 days for continuous protection</p>
      </div>
    </div>

    <div class="sofyre-user-manual__cta">${buttonHtml}</div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#F9F9F4',
  textColor: '#23372B',
  topPadding: true,
  bottomPadding: true,
});
